import { Button, Heading, Icon, IconType } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { openExternalUrl } from '@shared/utils/openExternalUrl'
import { NAMESPACE } from 'locale'
import { selfServeConstants } from 'locale/selfServe'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type Props = {
  qrCode?: string
  url?: string
}

export const AppStepCard: FC<Props> = ({ qrCode, url }) => {
  const { t } = useTranslation(NAMESPACE.SELF_SERVE)

  return (
    <CardWrapper>
      <ContentWrapper>
        <LeftWrapper>
          <StyledHeading level={3}>
            {t(selfServeConstants.APP_STEP_TITLE)}
          </StyledHeading>
          <StyledHeadingDesc level={5}>
            {t(selfServeConstants.APP_STEP_DESC)}
          </StyledHeadingDesc>
        </LeftWrapper>
        <RightWrapper>
          <img src={qrCode} alt={t(selfServeConstants.SCAN_TO_DOWNLOAD)} />

          <StyledScanText level={2}>
            {t(selfServeConstants.SCAN_TO_DOWNLOAD)}
          </StyledScanText>
        </RightWrapper>
      </ContentWrapper>
      <FooterWrapper>
        <StyledText level={1}>
          {t(selfServeConstants.STEP_X_OF_X, {
            from: '4',
            to: '4'
          })}
        </StyledText>
        <StyledButton variant="popout" onClick={() => openExternalUrl(url)}>
          {t(selfServeConstants.LINK_TO_APP)}
        </StyledButton>
      </FooterWrapper>
    </CardWrapper>
  )
}

const CardWrapper = styled.div`
  background-color: #fff8fa;
  padding: 18px;
  border-radius: 20px;
  margin-top: 18px;
  min-height: 280px;
  display: flex;
  flex-direction: column;
`

const FooterWrapper = styled.div`
  display: flex;
  margin-top: auto;
  align-items: center;
`

const ContentWrapper = styled.div`
  display: flex;
`

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;
`

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.status.popout};
  font-weight: 400;
  margin-bottom: 10px;
`

const StyledHeadingDesc = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.status.popout};
  margin-left: auto;
  margin-right: 0px;
`

const StyledScanText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
  white-space: nowrap;
  text-align: center;
  margin-top: 5px;
`

const StyledButton = styled(Button)`
  margin-bottom: 0px;
  width: fit-content;
  margin-left: 15px;
`
